import { Badge, IconButton, Tooltip } from "@mui/material";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { useSelector, useDispatch } from "react-redux";
import { IApplicationState } from "@/store-redux";
import { toggleDrawer } from "@/store-redux/slices/notificationSlice";
import { useGetUnreadCount } from "@/services-react-query/queries/notification.query";
import { keyframes } from "@mui/system";

const pulse = keyframes`
  0% { transform: scale(1); }
  50% { transform: scale(1.15); }
  100% { transform: scale(1); }
`;

export const NotificationBell = () => {
  const dispatch = useDispatch();
  const { unreadCount, isDrawerOpen } = useSelector((state: IApplicationState) => state.notification);

  // Polling fallback every 30s
  useGetUnreadCount();

  const hasUnread = unreadCount > 0;

  return (
    <Tooltip title="Notifications" arrow>
      <IconButton
        id="notification-bell-btn"
        onClick={() => dispatch(toggleDrawer())}
        size="small"
        sx={{
          position: "relative",
          color: isDrawerOpen ? "#6366F1" : "text.secondary",
          transition: "color 0.2s ease",
          "&:hover": { color: "#6366F1", bgcolor: "rgba(99, 102, 241, 0.08)" },
        }}
      >
        <Badge
          badgeContent={unreadCount > 99 ? "99+" : unreadCount}
          color="error"
          max={99}
          sx={{
            "& .MuiBadge-badge": {
              fontSize: "10px",
              fontWeight: 800,
              minWidth: "18px",
              height: "18px",
              padding: "0 4px",
              animation: hasUnread ? `${pulse} 2s ease-in-out infinite` : "none",
            },
          }}
        >
          {hasUnread ? <NotificationsIcon sx={{ fontSize: 22 }} /> : <NotificationsNoneIcon sx={{ fontSize: 22 }} />}
        </Badge>
      </IconButton>
    </Tooltip>
  );
};
